import CampaignHero from './CampaignHero';

export * from './types';
export default CampaignHero;
